import React from 'react'
import './CEO.css'
import { useAboutSection } from '../../../../context/AboutPageContext'
import RichTextContent, { CmsText } from '../../../RichTextContent/RichTextContent'
import { stripRichText } from '../../../../utils/richText'

import avatar from '../../../../assets/icons/about/Avatar.png'
import topVector from '../../../../assets/icons/about/upp.png'
import bottomVector from '../../../../assets/icons/about/bottom.png'

const CEO = () => {
  const { section, loading } = useAboutSection('ceo')

  if (loading || !section?.fields) return null

  const fields = section.fields

  return (
    <section className="ceo">
      <img src={topVector} alt="" className="ceo-vector top" />

      <div className="ceo-content">
        {fields.quote ? (
          <RichTextContent content={fields.quote} as="h2" className="ceo-text" />
        ) : null}

        <div className="ceo-info">
          <img src={avatar} alt={stripRichText(fields.name)} className="ceo-avatar" />

          <div className="ceo-meta">
            {fields.name ? (
              <CmsText content={fields.name} as="p" className="ceo-name" />
            ) : null}
            {fields.role ? (
              <CmsText content={fields.role} as="span" className="ceo-role" />
            ) : null}
          </div>
        </div>
      </div>

      <img src={bottomVector} alt="" className="ceo-vector bottom" />
    </section>
  )
}

export default CEO
